import React from "react";
import "../assets/css/nav.css";

const Navbar = () => {
  return (
    <>
      <button type="button" className="mobile-nav-toggle d-lg-none">
        <i className="icofont-navigation-menu"></i>
      </button>
      <header id="header" className="fixed-top">
        <div className="container-fluid  navbur">
          <div className="navi">
            <div className="col-xl-12 d-flex align-items-center lefty">
              <h5 className="col-xl-4 justify-content-start mr-auto devman">
                {/* <img
                  src="https://code.google.com/images/developers.png"
                  alt=""
                /> */}
                STILISKY <span className="blink"> _</span>
              </h5>
              <nav className="nav-menu  mainMenu">
                <ul>
                  <li
                    className="active"
                    data-aos="fade-down"
                    data-aos-duration="300"
                  >
                    <a href="#header"> Accueil</a>
                  </li>
                  <li data-aos="fade-down" data-aos-duration="600">
                    <a href="#about">A Propos</a>
                  </li>
                  <li data-aos="fade-down" data-aos-duration="900">
                    <a href="#services">Services</a>
                  </li>
                  <li data-aos="fade-down" data-aos-duration="1200">
                    <a href="#skills">Compétences</a>
                  </li>

                  <li data-aos="fade-down" data-aos-duration="1500">
                    <a href="#work">Mes Travaux</a>
                  </li>

                  <li data-aos="fade-down" data-aos-duration="1800">
                    <a href="#contact">Contactez-Moi</a>
                  </li>
                </ul>
              </nav>
              <div className="left-btns">
                {/* <div class=" " id="theme-button2">
                  <input id="toggle" class="toggle" type="checkbox"></input>
                </div> */}
                <div>
                  <div className="CvMe">
                    <a
                      href="https://drive.google.com/file/d/1cMqhzDoTbDFXpT2WL9KPlHAAdsqRsr72/view?usp=sharing"
                      download="STILISKY_CV.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    <button className="my-cv">Mon CV</button>
                    </a>
                  </div>
                </div>

                <div className=" " id="theme-button">
                  {/* <Link to="#" class="menuBtn">
                    <span class="lines"></span>
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
